export const ZH: Record<string, string> = {
  "Recommended for you": "为您推荐",
  "Resource added to favorite": "资源已添加到收藏夹",
  "Failed to add resource to favorite": "添加资源到收藏夹失败",
  "Resource removed from favorite": "资源已从收藏夹中移除",
  "Failed to remove resource from favorite": "从收藏夹中移除资源失败",
  "Calendar": "日历",
  "View Detail": "查看详情",
  "Add to favorites": "添加到收藏夹",
  "Remove from favorites": "从收藏夹中移除",
  "Description: VIP meeting room with a great view and comfortable chairs.": "描述：VIP会议室，拥有绝佳景观和舒适座椅。",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "在您选择的时间，您的位置或收藏夹中没有可用资源。",
  "You have these options:": "您有以下选项：",
  "Change the meeting time.": "更改会议时间。",
  "Use the <1>Find Available Time</1> button to choose a new time.": "使用<1>查找可用时间</1>按钮选择新时间。",
  "Open the search to find other resources.": "打开搜索以查找其他资源。",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "资源类型 <1>'{{resourceType}}'</1> 不存在于您的默认位置",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "资源类型 <1>'{{resourceType}}'</1> 可以在不同的位置找到。",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>点击这里</1> 将资源类型添加到您的默认位置设置中。",
  
  // ResourceCard
  "New Order": "新订单",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "预订Pooled资源时，只能预订此资源类型和只能预订一个。",
  "You cannot select both a child resource and its virtual resource at the same time.": "您不能同时选择一个子资源和它的虚拟资源。",
  // Settings
  "Note:": "注意：",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "助理组织者可以接收与组织者相同的Resource Central电子邮件，并可以代表组织者处理订单。",
  "Setting updated successfully": "设置更新成功",
  "Setting updated failed": "设置更新失败",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1个空间",
  "Opening hours:": "开放时间：",
  "Buffer time {{minutes}} mins between reservations": "预订之间的缓冲时间{{minutes}}分钟",
  "Initial payment {{value}} pr.minute": "初始付款{{value}}每分钟",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "共{{total}}位与会者",
  "{{internal}} of {{total}} internal can attend.": "{{total}}位内部人员中有{{internal}}位可以参加。",
  "{{external}} external is unknown.": "{{external}}位外部人员状态未知。",
  "Find available time": "查找可用时间",
  "Attendees": "与会者",
  
  // HelpSetting
  "Click on Further information to visit our support site": "点击更多信息访问我们的支持网站",
  "Further information": "更多信息",
  
  // LocationSetting
  "Location changed": "位置已更改",
  "Location change failed": "位置更改失败",
  "Please select at least one location": "请至少选择一个位置",
  "Resource types": "资源类型",
  "Location": "位置",
  "Where": "地点",
  
  // ModalShowAttendees
  "Total": "总计",
  "Available": "可用",
  "Busy": "忙碌",
  "External": "外部",
  "Internal": "内部",
  
  // ResourceSearch
  "Search by resource name": "按资源名称搜索",
  "Category": "类别",
  "Filter by Location": "按位置筛选",
  "Filter by Category": "按类别筛选",
  "Capacity": "容量",
  "Filter by Capacity": "按容量筛选",
  "All": "全部",
  "Filter by availability": "按可用性筛选",
  "Sort By": "排序方式",
  "Loading...": "加载中...",
  
  // SelectedResources
  "Meeting Type": "会议类型",
  "Meeting Label": "会议标签",
  
  // Alert (accessibility text)
  "Check icon": "复选图标",
  "Close": "关闭",
  
  // AppConstants - searchTab
  "Resource": "资源",
  "Person": "人员",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "您的会议通常在哪里举行？",
  "To improve our recommendations for you we would like you to enter your normal location": "为了改进我们对您的推荐，我们希望您输入常用位置",
  "What do you use most?": "您最常使用什么？",
  "To enable quicker and better search please chose you prefered resource type": "为了实现更快更好的搜索，请选择您首选的资源类型",
  
  // AppConstants - titlePages
  "Click on resource to pick": "点击资源以选择",
  "Selected Resources": "选定的资源",
  "Setting": "设置",
  "Search": "搜索",
  "Find Colleague": "查找同事",
  "Quick button setting": "快速按钮设置",
  "Favorite": "收藏",
  "Most Used": "最常用",
  "Colleagues": "同事",
  "Resources": "资源",
  
  // AppConstants - tooltipText
  "Back": "返回",
  "Floor Plan": "平面图",
  "Expand": "展开",
  "Selected resources": "选定的资源",
  "View details": "查看详情",
  "Remove from My Favorites": "从我的收藏夹中移除",
  "Add to My Favorites": "添加到我的收藏夹",
  "Remove": "移除",
  "Favorite - Most Used": "收藏 - 最常用",
  "Conflict": "冲突",
  "Approved": "已批准",
  "Recommendeded for you": "推荐给您",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "仅主要组织者",
  "Only assistant organizer": "仅助理组织者",
  "Primary AND assistant organizer": "主要和助理组织者",
  
  // FindColleague
  "Enter colleague name": "输入同事姓名",
  "Recent work items": "最近的工作项",
  "No data available": "无可用数据",
  "Floorplan": "平面图",
  "List nearby resources": "附近资源列表",
  "Find resource nearby": "查找附近资源",
  "No Resources available": "无可用资源",
  
  // Start page
  "Next": "下一步",
  "Failed to update default locations": "更新默认位置失败",
  "Resource Type": "资源类型",
  
  // QuickSetting
  "Quick buttons updated successfully": "快速按钮更新成功",
  "Quick buttons updated failed": "快速按钮更新失败",
  "Add more": "添加更多",
  "Apply": "应用",
  "Delete": "删除",
  "Name": "名称",
  "Enter name": "输入名称",
  "Tooltip": "工具提示",
  "Enter tooltip": "输入工具提示",
  "Type": "类型",
  "Select type": "选择类型",
  "Locations": "位置",
  "Select colleagues": "选择同事",
  "Select resources": "选择资源",
  
  // DefaultResourceSetting
  "Resource type changed": "资源类型已更改",
  "Resource type change failed": "资源类型更改失败",
  "Default Resource Type": "默认资源类型",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "应用成功",
  "Apply Failed": "应用失败",
  "Assistant Organizer": "助理组织者",
  "Enter a part of the name to search for": "输入部分名称以搜索",
  "Mail Flow": "邮件流",
  "Select Mail Flow": "选择邮件流",
  
  // TileConfigurationSetting
  "Update settings successfully": "设置更新成功",
  "Update settings failed": "设置更新失败",
  "Timeline": "时间线",
  
  // SelectCategoryForm
  "And": "与",
  "Or": "或",
  
  // Other
  "Resource Calendar": "资源日历",
  
  // SettingLabels
  "Default Location": "默认位置",
  "Quick button": "快速按钮",
  "Category icons": "类别图标",
  "Recommendation screen": "推荐屏幕",
  "Capacity filter": "容量过滤器",
  "AI Assistant": "AI助手",
  "Tile configuration": "磁贴配置",
  "Help": "帮助",
  "Default Categories": "默认类别",
  
  // MeetingType
  "Your must select a Meeting label": "您必须选择会议标签",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "所选资源: 'AOD_Copanhagen' 冲突的时段",
  "Alternative Resource": "备选资源",
  "OK": "确定",
  "Cancel": "取消",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "您选择的资源 'AOD_Copenhagen' 已被移除",
  "You can't book this resource as your request exceeds the available capacity.": "您无法预订此资源，因为您的请求超出了可用容量。",
  
  // ChangeTime
  "Time changed successfully": "时间更改成功",
  "Current Time": "当前时间",
  "Suggested Times": "建议时间",
  "Change Time": "更改时间",
  "people are free": "人员空闲",
};

